/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { SensitivityTooltipState, SensitivityTooltipSlots } from './SensitivityTooltip.types';
import { Preview, PreviewContent, PreviewTrigger } from '@fluentai/react-preview';

/**
 * Render the final JSX of SensitivityTooltip
 */
export const renderSensitivityTooltip_unstable = (state: SensitivityTooltipState) => {
  assertSlots<SensitivityTooltipSlots>(state);

  return (
    <state.root>
      {state.previewSurface && (
        <Preview trapFocus positioning={state.positioning}>
          <PreviewTrigger>{state.trigger && <state.trigger />}</PreviewTrigger>
          <state.previewSurface>
            <PreviewContent>
              {state.heading && <state.heading />}
              {state.message && <state.message />}
            </PreviewContent>
          </state.previewSurface>
        </Preview>
      )}
    </state.root>
  );
};
